import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';  // Certifique-se que esta linha está descomentada
import './WhatsAppButton.css';

function WhatsAppButton() {
  const phoneNumber = '5585999835383';
  const message = 'Olá! Gostaria de saber mais sobre os serviços de rastreamento.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contato via WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
      <span className="tooltip">Fale Conosco</span>
    </a>
  );
}

export default WhatsAppButton; 